import call from './httpClient';

const BASE_URL = `${import.meta.env.VITE_APP_NEXT_API_URL}/v1/orders`;

export const UpdateStatus = async ({ id, status }) => call({
  method: 'PUT',
  url: `${BASE_URL}/${id}/status`,
  data: {
    status,
  },
});

export const Get = async (id) => call({
  method: 'GET',
  url: `${BASE_URL}/${id}`,
});
